// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Aura Operations API
 * API to manage aura-operations
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const OperationscatalogFieldType = {
  FieldTypeText: 'text',
  FieldTypeInteger: 'integer',
  FieldTypeBoolean: 'boolean',
  FieldTypeChoice: 'choice',
  FieldTypeMultiline: 'multiline',
} as const;
export type OperationscatalogFieldType =
  (typeof OperationscatalogFieldType)[keyof typeof OperationscatalogFieldType];

export function instanceOfOperationscatalogFieldType(value: any): boolean {
  for (const key in OperationscatalogFieldType) {
    if (Object.prototype.hasOwnProperty.call(OperationscatalogFieldType, key)) {
      if (
        OperationscatalogFieldType[
          key as keyof typeof OperationscatalogFieldType
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function OperationscatalogFieldTypeFromJSON(
  json: any,
): OperationscatalogFieldType {
  return OperationscatalogFieldTypeFromJSONTyped(json, false);
}

export function OperationscatalogFieldTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OperationscatalogFieldType {
  return json as OperationscatalogFieldType;
}

export function OperationscatalogFieldTypeToJSON(
  value?: OperationscatalogFieldType | null,
): any {
  return value as any;
}

export function OperationscatalogFieldTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): OperationscatalogFieldType {
  return value as OperationscatalogFieldType;
}
